import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as ChartManager from '../domain/chart-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { SensorListDetails } from '../../types/device';

type ContextState = Data<SensorListDetails>;
const Context = React.createContext<ContextState | null>(null);

function useSensorListData(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useSensorListData must be used within a useSensorListDataProvider');
    }
    return contextState;
}

const SensorListDataProvider: React.FC<{ deviceId: string}> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'sensor-list',
        id: props.deviceId,
        dataFn: React.useCallback(() => ChartManager.getSensorListResponse(authHelper, props.deviceId), [
            authHelper,
            props.deviceId,
        ]),
    });

    const sensorData = dataFromDataset(dataset);

    return <Context.Provider value={sensorData}>{props.children}</Context.Provider>;
};

const TestSensorListDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { SensorListDataProvider, TestSensorListDataProvider, useSensorListData };

